import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import store from "./store";
import ErrorBoundary from "./components/ErrorBoundary";
// Import axios configuration to register interceptors globally
import "./api/axiosConfig";
// Import Sentry initialization (used only for targeted captures in Login flows)
import { initializeSentry } from "./config/sentry";

initializeSentry();

const root = createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);

reportWebVitals();
